import { render, staticRenderFns } from "./IbBtn.vue?vue&type=template&id=14d39f3c"
var script = {}
import style0 from "./IbBtn.vue?vue&type=style&index=0&id=14d39f3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports